module.exports = __webpack_public_path__ + "img/fondoAzul.804ef175.svg";